import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastCtx = createContext(null);
let _id = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => setToasts(t => t.filter(x => x.id !== id)), []);

  // 3rd arg is optional — existing 2-arg callers (toast(msg) / toast(msg, 'error'))
  // are unaffected. { action: { label, onClick } } renders a button inside the
  // toast (e.g. "Undo"); { duration } overrides the default auto-dismiss time.
  const toast = useCallback((msg, type = 'success', { action, duration = 3500 } = {}) => {
    const id = ++_id;
    setToasts(t => [...t, { id, msg, type, action }]);
    setTimeout(() => dismiss(id), duration);
  }, [dismiss]);

  return (
    <ToastCtx.Provider value={toast}>
      {children}
      <div className="toast-container" aria-live="polite" aria-atomic="false">
        {toasts.map(t => (
          <div key={t.id} className={`toast toast-${t.type}`} role="status">
            <span className="toast-msg">{t.msg}</span>
            {t.action && (
              <button
                className="toast-action"
                onClick={() => { t.action.onClick(); dismiss(t.id); }}
              >
                {t.action.label}
              </button>
            )}
            <button className="toast-dismiss" onClick={() => dismiss(t.id)} aria-label="Dismiss">×</button>
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast() {
  return useContext(ToastCtx);
}
